// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tourist-home-container[data-v-d9a9a7ba]{display:flex;flex-direction:column;font-family:Roboto;letter-spacing:0;text-align:left}.tourist-home-container>h2[data-v-d9a9a7ba]{font-weight:500;line-height:16px;font-size:14px;font-style:italic;letter-spacing:0;text-align:left;margin:30px 0}", ""]);
// Exports
module.exports = exports;
